import React from 'react';
import { branch, compose, withProps, renderComponent } from 'recompose';

export const Thumbnail = ({ media, className }) => <img src={media.url} className={className} />;

export const withThumbnailClass = withProps({
  className: 'thumbnail project__thumbnail--border',
});

const isSrcUndefined = ({ media }) => !media;

export const Thumb = compose(
  withThumbnailClass,
  branch(
    isSrcUndefined,
    renderComponent('div'),
  ),
)(Thumbnail);



// WEBPACK FOOTER //
// ./src/Account/Order/Thumb.js